export const parseEnumType = (typeArray, index) => typeArray[index - 1];
